export default ({request}) => ({
  merchantFunctionFormLanguageListApi(data = {}) {
    return request({
      url: '/sys/merchant/function/form/language/list',
      method: 'post',
      data,
    })
  },
  merchantFunctionFormLanguageDetailApi(data = {}) {
    return request({
      url: '/sys/merchant/function/form/language/detail',
      method: 'post',
      data,
    })
  },
  merchantFunctionFormLanguageAddApi(data = {}) {
    return request({
      url: '/sys/merchant/function/form/language/add',
      method: 'post',
      data,
    })
  },
  merchantFunctionFormLanguageUpdateApi(data = {}) {
    return request({
      url: '/sys/merchant/function/form/language/update',
      method: 'post',
      data,
    })
  },
  merchantFunctionFormLanguageDelApi(data = {}) {
    return request({
      url: '/sys/merchant/function/form/language/del',
      method: 'post',
      data,
    })
  },
})
